import React, { useState } from "react";
import csLogo from '../../assets/images/cybersquare_logo.png'
import successIcon from '../../assets/images/signupSuccessIcon.svg'
import errorIcon from '../../assets/images/signupErrorIcon.png'
import shareIcon from '../../assets/images/share-icon.svg';
import mailIcon from '../../assets/images/mail-icon.svg';
import whatsappIcon from '../../assets/images/whatsapp-logo.svg';
import { IconContext } from 'react-icons';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { jsPDF } from 'jspdf';


const CutomStatus = ({status, response,data}) => {
    const [showPassword, setShowPassword] = useState(false);
    const [showIcons, setShowIcons] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const toggleModal = () => {
        setShowIcons(!showIcons);
      };

    const shareWhatsapp = () => {
        const text = [
          "Congratulations on joining Cyber Square! We're excited to have you as part of our learning community.",
          "Reminder: Please make sure to save your login Credentials in a safe place.",
          " ",
          `URL:${data.companyUrl}`,
          `Username: ${data.userName}`,
          `Password: ${data.password}`,
          "",
          "Thanks for your cooperation!",
        ].join("\n");
        const encodedUri = encodeURIComponent(text);
        const link = `https://web.whatsapp.com/send?text=${encodedUri}`;
        window.open(link, "_blank");
      };
    
    const sendMail = (url) => {
        const defaultSubject =
          "Login Credentials";
        const defaultBody = [
          `
            Congratulations on joining Cyber Square! We're excited to have you as part of our learning community. 

            Reminder: Please make sure to save your login credentials in a safe place.

            🔗 URL: ${data.companyUrl}
            👤 Username: ${data.userName}
            🔑 Password: ${data.password}

            Thanks for your cooperation!
            `
        ].join("\n"); 
        
        const subject = encodeURIComponent(
           defaultSubject
        );
        
        const text = ( defaultBody)       
        const body = encodeURIComponent(text);
        const gmailLink = `https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&su=${subject}&body=${body}`;
        window.open(gmailLink, "_blank");
    };

    const downloadCred = async () => {

        const doc = new jsPDF();

        const imgLogo = 'https://99lmsfileuploadfolder.s3.ap-south-1.amazonaws.com/uploaded/companyLogo/companyLogo_r3qg8pxn.png';
        doc.addImage(imgLogo, 'PNG', 79, 10, 60, 15);

        doc.setFontSize(16);
        doc.text(`Welcome ${data.firstName}!`, 20, 40);

        doc.setFontSize(12);
        doc.text("Congratulations on joining Cyber Square! We're excited to have you", 20, 50);
        doc.text("as part of our learning community.", 20, 55);
        doc.text("Reminder: Please make sure to save your login credentials", 20, 66);
        doc.text("in a safe place.", 20, 71);
        doc.text("Welcome aboard, and happy learning!", 20, 82);

        const boxX = 20, boxY = 90, boxWidth = 170, boxHeight = 60;
        doc.setLineWidth(0.3);
        doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 3, 3);

        const credentialsText = "Credentials";
        const textWidth = doc.getTextWidth(credentialsText);
        const credentialsX = boxX + (boxWidth - textWidth) / 2;

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(credentialsText, (credentialsX - 3), boxY + 10);

        // Company URL text and padding
        const companyUrlText = `${data.companyUrl}`; // The text to be displayed inside the gray box
        const textPadding = 5; // Padding around the text
        const companyUrlWidth = doc.getTextWidth(companyUrlText) + (2 * textPadding); // Width of text plus padding

        const urlBoxX = boxX + (boxWidth - companyUrlWidth) / 2;
        const urlBoxY = boxY + 16;
        const urlBoxWidth = 110;
        const urlBoxHeight = 10;
        const cornerRadius = 3;
        doc.setFillColor(211, 211, 211);
        doc.roundedRect((urlBoxX - 10), urlBoxY, urlBoxWidth, urlBoxHeight, cornerRadius, cornerRadius, 'F');

        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");
        doc.text(companyUrlText, urlBoxX + textPadding, urlBoxY + 7);

        doc.text(`Username: ${data.userName}`,  boxX + 45, boxY + 38);
        doc.text(`Password: ${data.password}`, boxX + 45, boxY + 48);

        doc.save("download.pdf");
    }

    return(
        <>

            <div className='col-sm-8 col-md-7 col-lg-6 col-xl-6 col-12 p-4 rounded-4 form'>
                <div className="col-12 mt-0" style={{display:'flex', justifyContent:'center'}}>
                    <img src={csLogo} alt="cs_logo" style={{width:'300px'}} />
                </div>

                <div className="col-12 mt-2" style={{display:'flex', justifyContent:'center'}}>
                    <img style={{width: '30%'}} alt="status_image" src={status === 200 ? successIcon : errorIcon} />
                </div>
                <div className="col-12 mt-3" style={{display:'flex', justifyContent:'center'}}>
                    <span style={{fontSize: '26px'}}>
                        {status === 200 ? 'Welcome aboard! Your account is ready! ' : 'Sign up failed'}</span>
                </div>
                {status === 200 ? (
                    <>
                        <div className="text-center mb-5 mb-md-5 mt-5 mt-md-4 col-12" style={{ display: 'flex', justifyContent: 'center' }}>
                            <div className="text-center col-12 dwnld-box">
                                <div className="text-center col-12 mt-2 mb-2" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div className="text-center col-10 mt-2 mb-2">
                                        <span style={{ fontSize: '13px', fontWeight: 400 }}>Save these login details for easy access to your account!</span>
                                    </div>
                                </div>

                                <div className="text-center col-12 mt-2 mb-2" style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div className="col-10 linkBox">
                                        <a className="company-url" target="_blank" rel="noreferrer" href={`http://${data.companyUrl}`} >{data.companyUrl}</a>
                                    </div>
                                </div>

                                <div class="container text-center">
                                    <div class="row">
                                        <div class="col-md-8 offset-md-3">
                                            <div class="row g-3 align-items-center">
                                                <div class="col-auto">
                                                    <label for="inputPassword6" class="col-form-label">Username :</label>
                                                </div>
                                                <div class="col-auto">
                                                    <span className="text" >{data.userName}</span>
                                                </div>
                                            </div>

                                            <div class="row g-3 align-items-center">
                                                <div class="col-auto">
                                                    <label for="inputPassword6" class="col-form-label">Password :</label>
                                                </div>
                                                <div class="col-auto">
                                                    <span className="text" >
                                                        {!showPassword ? (
                                                             <>
                                                             {Array.from({ length: data.password.length }).map((_, index) => (
                                                               <span key={index} className="dot"></span>
                                                             ))}
                                                           </>
                                                        ) : (data.password)}
                                                    </span>
                                                </div>
                                                <div class="col-auto">
                                                    <IconContext.Provider value={{ size: '1.5em' }}>
                                                        <span className='input-group-text' onClick={togglePasswordVisibility} style={{ border: 'none', cursor: 'pointer', backgroundColor: 'transparent'}}>
                                                            {!showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                                        </span>
                                                    </IconContext.Provider>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className=" mb-3 mb-md-3 mt-3 mt-md-3 col-12" style={{display: 'flex', justifyContent: 'center'}}>
                                    <div className="col-3" style={{display: 'flex', justifyContent: 'center'}}>
                                        <button type="button" className="submit-btn" 
                                        data-testid='signInButton' onClick={downloadCred} >Download Credentials</button>
                                    </div>
                                    <div className="col-2">
                                        <button className="submit-btn" data-testid='signInButton' type="button" onClick={toggleModal}>
                                            <img
                                            src={shareIcon}
                                            alt="Share icon"
                                            title="Share Invite Link"
                                            />
                                        </button>
                                    </div>
                                </div>
                                {showIcons && (
                                        <div className="mb-3 mb-md-3 mt-1 mt-md-1 " style={{ display: 'flex', justifyContent: 'right',marginRight: '200px' }}>
                                            <div className="submit-btn pt-1" style={{ justifyContent: 'centere'}}>
                                                <img
                                                    onClick={sendMail}
                                                    src={mailIcon}
                                                    alt="Mail Icon"
                                                />
                                                <img
                                                    onClick={shareWhatsapp}
                                                    src={whatsappIcon}
                                                    alt="WhatsApp Icon"
                                                />
                                            </div>
                                        </div>
                                    )}
                                

                            </div>
                        </div>
                </>     
                ) : (null)}

            </div>
        </>
    )

}
export default CutomStatus